import {useContext, useState} from "react";
import {Stack, Typography} from "@mui/material";
import ErrorHandlingForm from "../../components/formValidation/ErrorHandlingForm";
import {validateRequired} from "../../components/formValidation/validators";
import CustomTextField from "../../components/formValidation/CustomTextField";
import CustomCountrySelect from "../../components/formValidation/CustomCountrySelect";
import ConfigContext from "../../context/ConfigContext";

const PersonBillingData = ({reference, data, setData}) => {
    const {config} = useContext(ConfigContext)
    const billingMandatory = config?.mandatory_billing_details === 'mandatory';

    const validateIfRequired = value => {
        if (billingMandatory) return validateRequired(value)
        return {
            valid: true,
            error: false
        }
    }
    const [errors, setErrors] = useState({
        billing_name: false,
        billing_country: false,
        billing_postal_code: false,
        billing_city: false,
        billing_address: false,
    });

    const validators = {
        billing_name: [validateIfRequired],
        billing_country: [validateIfRequired],
        billing_postal_code: [validateIfRequired],
        billing_city: [validateIfRequired],
        billing_address: [validateIfRequired],
    };

    return (
        <ErrorHandlingForm
            reference={reference}
            data={data}
            setData={setData}
            errors={errors}
            setErrors={setErrors}
            validators={validators}
        >
            <Stack spacing={1}>
                <Typography id="billing-name-label" variant="caption" color='primary.main'>
                    Számlázási név{billingMandatory && '*'}
                </Typography>
                <CustomTextField
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="billing_name"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-name-label",
                        "aria-required": billingMandatory ? "true" : "false",
                    }}
                />

                <Typography id="billing-country-label" variant="caption" color='primary.main'>
                    Ország{billingMandatory && '*'}
                </Typography>
                <CustomCountrySelect
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="billing_country"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-country-label",
                        "aria-required": billingMandatory ? "true" : "false",
                    }}
                />

                <Stack direction={{xs: 'column', md: 'row'}} width='100%' spacing={2}>
                    <Stack width='100%' spacing={1}>
                        <Typography id="billing-postal-code-label" variant="caption" color='primary.main'>
                            Irányítószám{billingMandatory && '*'}
                        </Typography>
                        <CustomTextField
                            data={data}
                            setData={setData}
                            errors={errors}
                            setErrors={setErrors}
                            validators={validators}
                            name="billing_postal_code"
                            variant="standard"
                            inputProps={{
                                "aria-labelledby": "billing-postal-code-label",
                                "aria-required": billingMandatory ? "true" : "false",
                            }}
                        />
                    </Stack>

                    <Stack width='100%' spacing={1}>
                        <Typography id="billing-city-label" variant="caption" color='primary.main'>
                            Város{billingMandatory && '*'}
                        </Typography>
                        <CustomTextField
                            data={data}
                            setData={setData}
                            errors={errors}
                            setErrors={setErrors}
                            validators={validators}
                            name="billing_city"
                            variant="standard"
                            inputProps={{
                                "aria-labelledby": "billing-city-label",
                                "aria-required": billingMandatory ? "true" : "false",
                            }}
                        />
                    </Stack>
                </Stack>

                <Typography id="billing-address-label" variant="caption" color='primary.main'>
                    Cím{billingMandatory && '*'}
                </Typography>
                <CustomTextField
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="billing_address"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-address-label",
                        "aria-required": billingMandatory ? "true" : "false",
                    }}
                />
            </Stack>
        </ErrorHandlingForm>
    );
};

export default PersonBillingData;
